export default {
  created_by_name: '',
  shipping_attributes: {
    number_assistants: 0,
    expected_delivery: null,
    is_new_address: false,
    address_id: null,
    whole_address: null,
    problems: null,
    shipping_value_aux: '0.00',
    shipping_value: null,
    driver_id: null,
    truck_id: null,
    building_id: null,
    building: {
      id: null
    },
    building_attributes: {
      address_attributes: {
        zip: null,
        addr: null,
        neighborhood: null,
        number: null,
        complement: null,
        city: null,
        state: null,
       }
    },
  },
  client_id: null,
  modality_id: null,
  client_name: null,
  is_default_client: false,
  kind: 'pickup',
  new_address_attributes:{},
  items_attributes: [],
  payments:{
    list:[],
    has_cash: false,
    cash_id: null,
    cash_idx: null,
    cash_idxes: [],
  },
  solution: 'retail',
  client_wants_email: "dont_want"
}